import { PublicClientApplication } from "@azure/msal-browser";
import { MICROSOFT_CLIENT_ID } from "../../config/config";

const msalConfig = {
  auth: {
    clientId: MICROSOFT_CLIENT_ID,
    authority:
      "https://login.microsoftonline.com/common/oauth2/v2.0/",
    redirectUri: window.location.origin
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

const MicrosoftSSO = ({ setMicrosoftUser, disabled = false }) => {
  const loginWithMicrosoft = async () => {
    if (disabled) return;

    try {
      await msalInstance.initialize(); // Ensure MSAL instance is initialized
      const loginResponse = await msalInstance.loginPopup({
        scopes: ["User.Read"]
      });

      // Get the ID token from the response - this is what we'll send to backend
      const idToken = loginResponse.idToken;

      const userData = {
        name: loginResponse.account.name,
        email: loginResponse.account.username,
        credential: idToken, // Add the ID token like Google SSO does
        account: loginResponse.account
      };

      localStorage.setItem("orbit_user_details", JSON.stringify(userData));

      // Pass user data to parent component
      setMicrosoftUser(userData);
    } catch (error) {
      console.error("Error during Microsoft login:", error);
    }
  };

  return (
    <button
      type="button"
      onClick={loginWithMicrosoft}
      disabled={disabled}
      className={`w-full flex items-center justify-center gap-2 px-4 py-3 border border-gray-200 rounded-lg transition-colors ${
        disabled
          ? "opacity-50 cursor-not-allowed"
          : "hover:bg-gray-50 cursor-pointer"
      }`}
    >
      <img src="/microsoft.svg" alt="Microsoft" className="w-5 h-5" />
      <span className="text-sm font-medium text-gray-700">Microsoft</span>
    </button>
  );
};

export default MicrosoftSSO;
